import { render } from "./KeywordInputBlock.vue?vue&type=template&id=a95366e0&scoped=true"
import script from "./KeywordInputBlock.vue?vue&type=script&lang=js"
export * from "./KeywordInputBlock.vue?vue&type=script&lang=js"

import "./KeywordInputBlock.vue?vue&type=style&index=0&id=a95366e0&lang=scss"
import "./KeywordInputBlock.vue?vue&type=style&index=1&id=a95366e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95366e0"]])

export default __exports__